export default "__VITE_ASSET__Cjr2rpaj__"